type FeaturePayOrderCheckParams = {
  loading: boolean
  plan: { isSubscription: boolean } | null
  subscriptionAgreementChecked: boolean
}

export const canCreateFeaturePayOrder = ({
  loading,
  plan,
  subscriptionAgreementChecked,
}: FeaturePayOrderCheckParams) => {
  if (loading || !plan) {
    return false
  }

  if (plan.isSubscription && !subscriptionAgreementChecked) {
    return false
  }

  return true
}
